import { MarriageAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage-non-resident';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNonResidentNotificationsCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={MarriageAnscNotificationsNonResidentMutationCrumbs()}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default ResearchMarriageNonResidentNotificationsCivilStatusPage;
